import { render, staticRenderFns } from "./chartOpex.vue?vue&type=template&id=7665cc48&"
import script from "./chartOpex.vue?vue&type=script&lang=js&"
export * from "./chartOpex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports